import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { PrimaryDiagnosisService } from 'src/app/services/core/primary-diagnosis/primary-diagnosis.service';
import { sweetAlert } from 'src/app/utils/swal';
import { urls } from 'src/app/utils/url.utils';
@UntilDestroy()
@Component({
  selector: 'app-add-primary-diagnosis',
  templateUrl: './add-primary-diagnosis.component.html',
  styleUrls: ['./add-primary-diagnosis.component.css']
})
export class AddPrimaryDiagnosisComponent implements OnInit {
  diagnosisForm!: FormGroup;
  submitted = false;
  primaryDiagnosisId: any;

  @Input() primaryDiagnosis: any;
  @Input() source: any;
  @Output() onSavePrimaryDiagnosis = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private primaryDiagnosisService: PrimaryDiagnosisService,
  ) { }

  ngOnInit(): void {
    if (this.source === 'modal' && this.primaryDiagnosis) {
      this.primaryDiagnosisId = this.primaryDiagnosis.id;
      this.getById();
    } else {
      this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((param) => {
        if (param && param['id']) {
          this.primaryDiagnosisId = param['id'];
          this.getById();
        }
      });
    }

    this.diagnosisForm = this.fb.group({
      title: ["", Validators.required],
      code: ["", Validators.required],
      isActive: [true, Validators.required],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.diagnosisForm.invalid) return;
    const payload = this.diagnosisForm.value;

    this.primaryDiagnosisService
      .save(this.primaryDiagnosisId, payload)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
      if (data) {
        if (this.source === 'modal') {
          this.onSavePrimaryDiagnosis.emit(data);
        } else {
          this.router.navigateByUrl('/billing/primary-diagnosis');
        }
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "OK");
    }
    )
  }

  getById() {
    this.primaryDiagnosisService
      .getById(this.primaryDiagnosisId)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.diagnosisForm.patchValue(data)
        }
      });
  }

  get form() {
    return this.diagnosisForm.controls;
  }
}
